<div class="changelog-page">
  <app-page-title
    title="Novedades"
    subtitle="Qué cambió en cada versión de IRIX"
    icon="new_releases"
  ></app-page-title>

  @if (cargando) {
    <div class="changelog-loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else {
    <div class="changelog-contenido">
      <markdown [data]="changelogMd"></markdown>
    </div>
  }
</div>
